__turbopack_context__.v({
  "container": "MessagePanel-module__p64h7W__container",
});
